import styled from 'styled-components';

import { TextEditor, TextEditorProps } from '@components/text-editors';
import {
  ExtendedFieldMappingEditorValue,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { EditorValue } from '@components/text-editors/text-editor';
import { pxToRem } from '@utils/converters';

import { insertTokenNode, Token, transformInput, tag } from './extensions';

export type TokenListFieldProps = Omit<TextEditorProps, 'defaultValue' | 'onChange'> & {
  defaultValue?: EditorValue[];
  onChange?: (value: ExtendedFieldMappingEditorValue[]) => void;
};

export const TokenListField = ({ defaultValue, onChange, ...rest }: TokenListFieldProps) => {
  return (
    <StyledEditor
      extensions={[Token.configure()]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag))}
      onEditorBlur={insertTokenNode}
      defaultValue={defaultValue ? transformInput(defaultValue) : undefined}
      {...rest}
    />
  );
};

const StyledEditor = styled(TextEditor)({
  '.node-wrapper': {
    marginRight: pxToRem(8),
  },
});
